import React, { useEffect, useState } from "react";
import "./radio.css";
import classNames from "classnames";

export default function Radio(props) {
  // 导航栏默认选项
  const [watch, setWatch] = useState(1);
  // 导航栏数据
  const menulist = [
    { id: 1, msg: "推荐" },
    { id: 2, msg: "体育" },
    { id: 3, msg: "汽车" },
    { id: 4, msg: "科技" },
    { id: 5, msg: "健康" },
    { id: 6, msg: "内地" },
    { id: 7, msg: "外媒" },
    { id: 8, msg: "文娱" },
  ];

  const news = props.news.slice(0, 5);

  useEffect(() => {}, [watch]);

  useEffect(() => {
    props.fixNum(watch);
  });

  return (
    <div className="radio">
      {/* 导航栏 */}
      <div className="radio-menu">
        {/* 导航栏每一项 */}
        {menulist.map((item) => {
          return (
            <div className="radio-menulist" key={item.id}>
              {/* 顶部小绿块 */}
              {item.id === watch && <div className="radio-br"></div>}
              <span
                className={classNames({ "color-green": item.id === watch })}
                onClick={() => {
                  setWatch(item.id);
                }}
              >
                {item.msg}
              </span>
            </div>
          );
        })}
      </div>

      <div className="radio-div">
        {/* 文章列表 */}
        <div className="radio-new">
          {news !== [] && (
            <>
              {news.map((todo) => {
                return (
                  <div className="radio-newlist" key={todo.url} onClick={() => {
                    window.open(
                      todo.url
                    )
                  }}>
                    {/* 文章图片 */}
                    {todo.thumbnail_pic_s === "" && (
                      <img
                        src={require("../Movie/img/none.jpg")}
                        alt=""
                        className="radio-newlist-img"
                        onClick={() => {
                          window.open(todo.url);
                        }}
                      />
                    )}
                    {todo.thumbnail_pic_s !== "" && (
                      <img
                        src={todo.thumbnail_pic_s}
                        alt=""
                        className="radio-newlist-img"
                        onClick={() => {
                          window.open(todo.url);
                        }}
                      />
                    )}

                    {/* 文章信息 */}
                    <div className="radio-newlist-right">
                      {/* 右边标题 */}
                      <div className="radio-right-title">
                        <span
                          onClick={() => {
                            window.open(todo.url);
                          }}
                        >
                          {todo.title}
                        </span>
                      </div>
                      {/* 右边时间 */}
                      <div className="radio-right-area">
                        <span>{todo.author_name}</span>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <span>{todo.date}</span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
